import { getAssets, getSelectedProjectId } from 'owa-timestream-store';
import type { BucketPayload } from '../schema';

export default function getAllBucketsInfo() {
    return getAssets(getSelectedProjectId())
        .filter(([id, asset]) => asset.type === 'bucket' && !asset.deleted)
        .map(([id, asset]) => {
            const { name, charmId } = asset.payload as BucketPayload;
            return { id, name, charmId };
        });
}
